/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSfCampaigns200Response } from '../models';
// @ts-ignore
import { GetSfOpportunityRequiredObjectFields200Response } from '../models';
/**
 * SfCampaignsApi - axios parameter creator
 * @export
 */
export const SfCampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Salesforceのキャンペーン一覧
         * @summary Salesforceのキャンペーン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCampaigns: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Salesforceの商談の必須項目一覧
         * @summary Salesforceの商談の必須項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfOpportunityRequiredObjectFields: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_opportunities/required_object_fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SfCampaignsApi - functional programming interface
 * @export
 */
export const SfCampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SfCampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Salesforceのキャンペーン一覧
         * @summary Salesforceのキャンペーン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfCampaigns(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfCampaigns200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfCampaigns(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Salesforceの商談の必須項目一覧
         * @summary Salesforceの商談の必須項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfOpportunityRequiredObjectFields(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfOpportunityRequiredObjectFields200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfOpportunityRequiredObjectFields(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SfCampaignsApi - factory interface
 * @export
 */
export const SfCampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SfCampaignsApiFp(configuration)
    return {
        /**
         * Salesforceのキャンペーン一覧
         * @summary Salesforceのキャンペーン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfCampaigns(options?: any): AxiosPromise<GetSfCampaigns200Response> {
            return localVarFp.getSfCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * Salesforceの商談の必須項目一覧
         * @summary Salesforceの商談の必須項目一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfOpportunityRequiredObjectFields(options?: any): AxiosPromise<GetSfOpportunityRequiredObjectFields200Response> {
            return localVarFp.getSfOpportunityRequiredObjectFields(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SfCampaignsApi - interface
 * @export
 * @interface SfCampaignsApi
 */
export interface SfCampaignsApiInterface {
    /**
     * Salesforceのキャンペーン一覧
     * @summary Salesforceのキャンペーン一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCampaignsApiInterface
     */
    getSfCampaigns(options?: AxiosRequestConfig): AxiosPromise<GetSfCampaigns200Response>;

    /**
     * Salesforceの商談の必須項目一覧
     * @summary Salesforceの商談の必須項目一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCampaignsApiInterface
     */
    getSfOpportunityRequiredObjectFields(options?: AxiosRequestConfig): AxiosPromise<GetSfOpportunityRequiredObjectFields200Response>;

}

/**
 * SfCampaignsApi - object-oriented interface
 * @export
 * @class SfCampaignsApi
 * @extends {BaseAPI}
 */
export class SfCampaignsApi extends BaseAPI implements SfCampaignsApiInterface {
    /**
     * Salesforceのキャンペーン一覧
     * @summary Salesforceのキャンペーン一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCampaignsApi
     */
    public getSfCampaigns(options?: AxiosRequestConfig) {
        return SfCampaignsApiFp(this.configuration).getSfCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Salesforceの商談の必須項目一覧
     * @summary Salesforceの商談の必須項目一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfCampaignsApi
     */
    public getSfOpportunityRequiredObjectFields(options?: AxiosRequestConfig) {
        return SfCampaignsApiFp(this.configuration).getSfOpportunityRequiredObjectFields(options).then((request) => request(this.axios, this.basePath));
    }
}
